/**
 * Enums for booking events, verbatim from `utils/functions.js`.
 *
 * `eventSubscriberVisibility` is a bit flag set (1, 2, 4, 8, 16, 32) but the
 * original's select treated it as a plain list of alternatives — reproduced
 * here rather than "fixed", since the API is the authority on which it is.
 */

export const EVENT_TYPES = [
  { value: 0, labelKey: 'events.type.rental' },
  { value: 1, labelKey: 'events.type.class' },
  { value: 2, labelKey: 'events.type.other' },
  { value: 3, labelKey: 'events.type.yoga' },
  { value: 4, labelKey: 'events.type.service' },
  { value: 5, labelKey: 'events.type.none' },
] as const;

/** Type 2 ("other") is the drop-in event that has a public page to link to. */
export const TYPE_DROP_IN = 2;

export function eventTypeLabelKey(value: number | null | undefined) {
  return EVENT_TYPES.find((o) => o.value === value)?.labelKey ?? 'events.type.none';
}

/** The filter excludes type 5, exactly as the original's row did. */
export const EVENT_TYPE_FILTERS = EVENT_TYPES.filter((o) => o.value !== 5);

export const SUBSCRIBER_VISIBILITY = [
  { value: 1, labelKey: 'events.visibility.free' },
  { value: 2, labelKey: 'events.visibility.tier1' },
  { value: 4, labelKey: 'events.visibility.tier2' },
  { value: 8, labelKey: 'events.visibility.tier3' },
  { value: 16, labelKey: 'events.visibility.tier4' },
  { value: 32, labelKey: 'events.visibility.anySubscription' },
] as const;

export function visibilityLabelKey(value: number | null | undefined) {
  return (
    SUBSCRIBER_VISIBILITY.find((o) => o.value === value)?.labelKey ??
    'events.visibility.free'
  );
}

export const BOOKING_STATUS = [
  { value: 0, labelKey: 'events.bookingStatus.pending', tone: 'warning' },
  { value: 1, labelKey: 'events.bookingStatus.confirmed', tone: 'success' },
  { value: 2, labelKey: 'events.bookingStatus.cancelled', tone: 'destructive' },
] as const;

export function bookingStatusMeta(value: number | null | undefined) {
  return (
    BOOKING_STATUS.find((o) => o.value === value) ?? BOOKING_STATUS[0]
  );
}

/** The four lists the time-slot drawer pages through, by its `type` query. */
export const TIME_SLOT_TABS = [
  { type: 0, labelKey: 'events.slots.activeUpcoming' },
  { type: 1, labelKey: 'events.slots.activePast' },
  { type: 2, labelKey: 'events.slots.inactiveUpcoming' },
  { type: 3, labelKey: 'events.slots.inactivePast' },
] as const;
